import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  Row,
  Title,
  Copy
} from "app/NativeComponents/common";

import moment from "moment";

class PromoCode extends Component {
  renderRedeemCount() {
    if (this.props.promo_code.redeemed_count != 0) {
      return (
        <Copy>Redeemed: {this.props.promo_code.redeemed_count} times</Copy>
      );
    } else if (
      this.props.promo_code.redeemed_count > 0 &&
      this.props.promo_code.redeemed_count < 2
    ) {
      return <Copy>Redeemed: 1 time</Copy>;
    } else {
      return <Wrapper />;
    }
  }

  render() {
    return (
      <Wrapper>
        <CardBody>
          <Row>
            <Wrapper>
              <Title>{this.props.promo_code.promo}</Title>
              <Copy>Link: {this.props.promo_code.dynamic_link}</Copy>
              <Copy>
                Created:{" "}
                {moment(this.props.promo_code.date_created).format(
                  "MMMM Do, YYYY"
                )}
              </Copy>
              <Copy>
                Promo offer: {this.props.promo_code.free_credits / 200}{" "}
                DealCredits
              </Copy>
              {this.renderRedeemCount()}
            </Wrapper>
          </Row>
        </CardBody>
      </Wrapper>
    );
  }
}

export default PromoCode;
